// This file contains the data for the research articles.

export const researchArticles = [
    {
        category: 'Publication',
        date: 'Jul 17, 2025',
        title: 'ChatGPT Agent System Card',
        description: 'ChatGPT Agent System Card: OpenAI’s agentic model unifies research, browser automation, and code tools with safeguards under the Preparedness Framework.',
    },
    {
        category: 'Product',
        date: 'Jul 17, 2025',
        title: 'Introducing ChatGPT agent',
        description: 'Introducing ChatGPT agent: it thinks and acts, using tools to complete tasks like research, bookings, and slideshows—all with your guidance.',
    },
    {
        category: 'Publication',
        date: 'Jun 18, 2025',
        title: 'Toward understanding and preventing misalignment generalization',
        description: 'We study how training on incorrect responses can cause broader misalignment in language models and identify an internal feature driving this behavior—one that can be reversed with targeted fine-tuning.',
    },
    {
        category: 'Safety',
        date: 'May 23, 2025',
        title: 'Addendum to OpenAI o3 and o4-mini system card: OpenAI o3 Operator',
        description: 'We are replacing the existing GPT-4o-based model for Operator with a version based on OpenAI o3. The API version will remain based on 4o.',
    },
    {
        category: 'Safety',
        date: 'May 16, 2025',
        title: 'Addendum to o3 and o4-mini system card: Codex',
        description: 'Codex is a cloud-based coding agent. Codex is optimized for software engineering. Codex is a version of OpenAI o3 that has been fine-tuned on a large dataset of code from GitHub.',
    },
];
